export const getNavData = state => {
  const data = state.cvNavData?.navData?.main || [];
  return data;
};

export const getSubNodes = state => {
  const data = state.cvNavData?.navData?.selected || {};
  return data;
};

export const getNodeBehavior = state => {
  const data = state.cvNavData?.navData?.selected?.app_behaviour || '{}';
  return JSON.parse(data);
};
